<script>
    export let name;
    export let legalDocName;

    let legalContent = null;

    async function getLegalContent(legalDocName) {
        try {
            let content = await fetch(`${document.location.protocol}//${document.location.host}/legal-res/${legalDocName}.html`);
            legalContent = await content.text();
        } catch (ex) {
            console.error(`There was a problem getting legal content for ${legalDocName}.`);
            window.location.href = `${window.location.protocol}//${window.location.host}/404`;
        }
    }

    getLegalContent(legalDocName);
</script>

<style>
	.container {
		display: flex;
		flex-flow: column nowrap;
        max-width: 700px;
        width: 100%;
        align-self: center;
	}

    .legalTitle {
        font-weight: 200;
        font-size: 50px;
        line-height: 90%;
        margin-top: 100px;
        margin-bottom: 70px;
        padding: 20px;
    }

    .httpiness {
        width: 140px;
        height: 26px;        
        display: inline-block;
        position: relative;
        top: 6.5px;
        background-position: center left;
        background-size: contain;
        background-repeat:no-repeat;
        background-image: url('./../images/wordmark.svg');
    }

    .legalContent {
        margin-left: 20px;
        margin-right: 20px;
    }

</style>

<div class="container">
    <div class="legalTitle">
        <a href="/"> <span class="httpiness" /> </a><br>
        {name}
    </div>
    <div class="legalContent">{@html legalContent}</div>
</div>